<template>
    <div class="n-ptb-4">

        <div class="n-p-4 c-max-width n-m-auto">
            <div v-if="$route.query.from == 'bookDetail'"
                 class="success-message n-col-1 n-radius-10 n-p-4 n-mb-4 n-flex n-flex-a-c n-flex-j-sb">
                <div class="n-flex n-flex-a-c n-flex-g">
                    <CheckCircleOutlined class="n-c-green n-mr-3"
                                         style="font-size: 24px;" />
                    <div>
                        <h4 class="n-f-bold n-f-10 n-m-0 n-c-green">{{LAN.cart.bookAddedToCart}}</h4>
                        <p class="n-c-3 n-m-0">{{LAN.cart.bookAddedToCartDesc}}</p>
                    </div>
                </div>

                <a-button type="primary"
                          shape="round"
                          class="c-tab-link c-tab-link-event"
                          v-if="canBack()"
                          @click="$router.go(-1)">
                    <template #icon>
                        <LeftOutlined />
                    </template>
                    {{LAN.common.back}}
                </a-button>
            </div>

            <div class="n-bg-1 n-radius-10 n-p-4">
                <div v-if="loading">
                    <ul class="n-ul n-p-0 list n-bg-1 n-mt-2">
                        <li class="n-b-line n-pointer n-p-4"
                            v-for="item in 3"
                            :key="item">
                            <div class="n-skeleton n-skeleton-text n-ptb-4 n-col-3"></div>
                            <div class="n-skeleton n-skeleton-text n-ptb-4 n-mt-3"></div>
                        </li>
                    </ul>
                </div>

                <div v-else-if="cartList.length === 0"
                     class="n-flex n-flex-c n-flex-a-c n-flex-j-c n-p-6 n-flex-dr-c">
                    <ShoppingCartOutlined style="font-size: 120px;"
                                          class="n-c-2" />

                    <h3 class="n-f-normal n-f-6 n-c-2 n-mt-6 n-mb-3">{{LAN.cart.emptyCart}}</h3>

                    <router-link :to="{ name: 'book' }"
                                 class="c-tab-link c-tab-link-event">
                        <a-button type="primary"
                                  shape="round"
                                  size="large">{{LAN.cart.backToBrowse}}</a-button>
                    </router-link>
                </div>

                <div v-else>
                    <view :to="{ name: 'BDetail', query: {from: 'cart', id: item.bid} }"
                          v-for="(item, index) in cartDetailList"
                          :key="index"
                          class="n-flex n-flex-a-c n-ptb-3 n-b-line ">
                        <div class="n-flex-s n-mr-3">
                            <a-checkbox v-model:checked="item.checked"
                                        @change="onCheckboxChange"
                                        @click.stop="() => {}"></a-checkbox>
                        </div>

                        <router-link :to="{ name: 'BDetail', query: {from: 'cart', id: item.bid} }"
                                     class="c-tab-link c-tab-link-event n-flex-g n-flex n-flex-a-c">
                            <div class="n-flex-s n-mr-4">
                                <NImage class="cart-item-image"
                                        type="cover"
                                        :zoomView="false"
                                        :src="item.coverPicture">
                                </NImage>
                            </div>

                            <div class="n-flex-g n-flex-g-w-1-hack">
                                <h4 class="n-f-bold n-f-10 n-c-4 n-m-0 n-line-height-1">{{ item.title || '-' }}</h4>
                                <p class="n-f-6 n-c-3 n-m-0 n-mt-4">ISBN: {{ item.isbn || '-' }}</p>
                                <p class="n-f-6 n-c-3 n-m-0 n-mt-1">{{LAN.common.publishDate}}: {{ item.publishDate }}</p>
                                <p class="n-f-10 n-f-bold n-c-base n-m-0 n-mt-2">{{LAN.common.salePrice}}: {{item.currency}}{{ item.listPrice }}</p>
                            </div>
                        </router-link>

                        <div class="n-flex-s n-ml-4">
                            <a-button type="primary"
                                      shape="circle"
                                      class="delete-icon-btn"
                                      @click.stop="removeItem(item.objId)">
                                <template #icon>
                                    <DeleteOutlined />
                                </template>
                            </a-button>
                        </div>
                    </view>

                    <div class="n-flex n-flex-a-c n-flex-j-sb n-pt-4">
                        <h4 class="n-f-4 n-c-2">{{ LAN.cart.downloadTip }}</h4>
                        <h3 class="n-f-bold n-m-0 n-flex-g n-text-right n-mlr-4 n-c-base n-flex-s"
                            v-if="selectedIsCommonCurrency">{{LAN.cart.totalItems.replace('=COUNT=', selectedItems.length).replace('=UNIT=',selectedItems.length > 1 ? 's' : '')}}{{ selectedIsCommonCurrency + totalPrice }}</h3>

                        <a-button type="primary"
                                  class="n-flex-s"
                                  :disabled="!hasSelectedItems || !selectedIsCommonCurrency"
                                  v-if="userInfo?.type && userInfo?.type == 'personal'"
                                  @click="checkPaid">{{LAN.cart.checkout}}</a-button>

                        <a-tooltip placement="topRight"
                                   :trigger="['hover', 'click']"
                                   :overlayStyle="{ width: 'auto', maxWidth: 'none' }"
                                   v-else>
                            <template #title>
                                <div class="n-flex n-flex-a-c">
                                    <span class="n-flex-s n-mr-2">{{ LAN.book.goLogin }}</span>
                                    <a href="javascript:;"
                                       class="c-link-blue c-tab-link c-tab-link-event n-flex-s"
                                       @click="$emit('personallogin')">{{ LAN.book.goLoginText }}</a>
                                </div>
                            </template>
                            <a-button type="primary"
                                      class="n-flex-s"
                                      :disabled="true">{{LAN.cart.checkout}}</a-button>
                        </a-tooltip>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <Buy v-if="showBuy"
         :show="showBuy"
         :data="selectedItems"
         @cancel="showBuy = false" />

    <a-modal ref="modalRef"
             centered
             v-model:visible="showPaid"
             :footer="null"
             :title="LAN.cart.confirmPaid.replace('=UNIT=', (selectedPaidItems||[]).length > 1 ? 's' : '')"
             :wrap-style="{ overflow: 'hidden' }">
        <div v-for="(item, index) in selectedPaidItems"
             :key="index"
             class="n-flex n-flex-a-c n-ptb-3">
            <div class="n-flex-s n-mr-4">
                <NImage class="cart-item-image"
                        type="cover"
                        :lazy="false"
                        :zoomView="false"
                        :src="item.coverPicture">
                </NImage>
            </div>

            <div class="n-flex-g n-flex-g-w-1-hack">
                <h4 class="n-f-bold n-f-10 n-c-4 n-m-0 n-line-height-1">{{ item.title || '-' }}</h4>
                <p class="n-f-6 n-c-3 n-m-0 n-mt-4">ISBN: {{ item.isbn || '-' }}</p>
                <p class="n-f-6 n-c-3 n-m-0 n-mt-1">{{LAN.common.publishDate}}: {{ item.publishDate }}</p>
                <p class="n-f-10 n-f-bold n-c-base n-m-0 n-mt-2">{{LAN.common.salePrice}}: {{item.currency}}{{ item.listPrice }}</p>
            </div>
        </div>
    </a-modal>
</template>

<script>
    import { mapMutations, mapState } from 'vuex';
    import NImage from '@/components/nui/NImage/NImage.vue'
    import Breadcrumb from '@/components/Breadcrumb.vue'
    import nui from '@/assets/script';
    import indexedDBManager from '@/assets/script/indexedDB';
    import { ShoppingCartOutlined, CheckCircleOutlined, DeleteOutlined } from '@ant-design/icons-vue';
    import Buy from '@/components/Buy.vue'
    import { getStore } from '@/assets/script/store';

    export default {
        name: 'ShoppingCart',
        computed: {
            ...mapState(nui.extendVue.extendState.concat(['cartList'])),

            totalPrice () {
                return parseFloat(this.cartDetailList.reduce((total, item) => {
                    return total + (item.listPrice * (item.quantity || 1));
                }, 0)).toFixed(2);
            },

            hasSelectedItems () {
                return this.cartDetailList.some(item => item.checked);
            },

            selectedItems () {
                return this.cartDetailList.filter(item => item.checked);
            },

            selectedIsCommonCurrency () {
                return this.selectedItems?.length > 0 && this.selectedItems.every(item => item.currency === this.selectedItems[0].currency) ? this.selectedItems[0].currency : false;
            }
        },
        data () {
            return nui.extend(true, {}, nui.extendVue.extendData, {
                loading: false,
                cartDetailList: [],
                selectedPaidItems: [],
                showBuy: false,
                showPaid: false,
                userInfo: {}
            })
        },
        methods: nui.extend(true, {}, nui.extendVue.extendMethods, {
            ...mapMutations(nui.extendVue.extendMutations.concat()),

            async NActivated () {
                this.userInfo = getStore({ name: 'userInfo' }) || { type: '' };

                // 购物车页面激活时的逻辑
                await this.$store.dispatch('cacheCartList');
                this.loadingData();

            },
            async NMounted () {
                await this.$store.dispatch('cacheCartList');
                this.loadingData();
            },

            async loadingData () {
                this.loading = true;

                this.request(this.API.cartList, {
                    method: 'post',
                    data: this.cartList.map(item => {
                        return {
                            objId: item.id,
                            objType: "BOOK"
                        }
                    })
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this.cartDetailList = res.data.map(item => {
                            item.bid = this.cartList.find(cartItem => cartItem.id == item.objId)?.bid;

                            return {
                                ...item,
                                checked: false // 默认不选中
                            }
                        });
                    }
                    this.loading = false;
                });

            },

            async removeItem (itemId) {
                await indexedDBManager.removeFromCart(itemId);
                this.cartDetailList = this.cartDetailList.filter(item => item.objId != itemId);

                this.$store.dispatch('cacheCartList');
            },

            onCheckboxChange () {
                // checkbox状态变化时的处理逻辑
                // 这里可以添加额外的逻辑，比如更新总价等
            },

            checkPaid () {
                this.request(this.API.checkPaid, {
                    method: 'post',
                    data: this.selectedItems.map(item => {
                        return {
                            objId: item.objId,
                            objType: "BOOK"
                        }
                    })
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        const paidIds = res.data.map(item => item.objId);
                        const paidIdItems = this.cartDetailList.filter(item => paidIds.includes(item.objId));

                        this.selectedPaidItems = paidIdItems;

                        if (this.selectedPaidItems.length > 0) {
                            this.selectedItems = this.selectedItems.filter(item => !paidIds.includes(item.objId));

                            this.showPaid = true;
                        } else {
                            this.showBuy = true;
                        }
                    } else {
                        this.$message.error(res.msg);
                    }
                })
            },

            continuePaid () {
                // const paidIds = this.selectedPaidItems.map(item => item.objId);

                // this.cartDetailList = this.cartDetailList.map(item => {
                //     item.checked = !paidIds.includes(item.objId);

                //     return item;
                // })

                // if (this.cartDetailList.length === 0) {
                //     this.showPaid = false;
                // } else {
                //     this.showBuy = true;
                // }
            }
        }),
        components: {
            NImage,
            Breadcrumb,
            Buy,
            ShoppingCartOutlined,
            CheckCircleOutlined,
            DeleteOutlined
        },
        ...nui.extendVue.extendLife
    }
</script>
<style lang="scss" scoped>
    .cart-item-image {
        width: 104px;
        height: 148px;
    }

    .success-message {
        border: 1px solid #52c41a;
        background-color: #f6ffed;
    }
</style>